module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-Semibold-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-Semibold-webfont.woff
// module id = 362
// module chunks = 0